module.exports = __webpack_public_path__ + "media/2022/newsweek-logo-89b0541e.svg";